import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import type { CalendarSettings } from "../types";
import type { UseQueryOptions } from "@tanstack/react-query";
type OverrideOptions = Omit<Partial<UseQueryOptions<CalendarSettings>>, "queryKey" | "queryFn">;

/**
 * Fetches calendar-related settings from user_external_services only
 * (hasCalendar, linkedSources, linkedBySource). Use this instead of
 * userSettings.calendarType / calendarId.
 *
 * Invalidate with QUERY_KEYS.CALENDAR_SETTINGS when the user links/unlinks a calendar.
 */
export function useCalendarSettings(options) {
  const $ = _c(5);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = () => apiFetcher("/api/v1/user/settings/calendar");
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== options || $[3] !== t0) {
    t1 = {
      queryKey: QUERY_KEYS.CALENDAR_SETTINGS,
      queryFn: t0,
      staleTime: 300000,
      gcTime: 600000,
      ...options
    };
    $[2] = options;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useQuery(t1);
}